import "./ProfileButton.scss";
import React, { useEffect, useState } from "react";
import avatarImage from "../../assets/images/avatar.webp";
import { useNavigate } from "react-router-dom";

const ProfileButton: React.FC<any> = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");

  // handling profile till we get profile CRUD APIs
  useEffect(() => {
    const userEmail = localStorage.getItem("userEmail");

    if (userEmail === "operation@cnbtek.com") {
      setUsername("Amir Pathan");
    } else if (userEmail === "nakshfed@cnbtek.com") {
      setUsername("Naksh Federation");
    } else if (userEmail === "it@acmpl.co") {
      setUsername("Prashant Patil");
    } else if (userEmail === "globiconfed@cnbtek.com") {
      setUsername("Globicon Terminals");
    } else {
      setUsername("Demo Fed");
    }
  }, []);

  return (
    <div
      className="profile-button relative inline-block"
      title="Click to view profile"
    >
      <button
        onClick={() => navigate("/profile")}
        className="flex items-center space-x-3 focus:outline-none"
        // title="CNB Integrated Logistics Solutions Pvt. Ltd."
      >
        <img
          src={avatarImage}
          alt="Profile"
          className="h-[45px] w-[45px] rounded-full"
        />
        <div className="text-left">
          <div className="font-[500] text-[16px] text-mainText overflow-hidden truncate w-[129px]">
            {username}
          </div>
          <div className="text-[14px] text-subText leading-[16px]">
            Federation Admin
          </div>
        </div>
      </button>
    </div>
  );
};

export default ProfileButton;
